import React, { useEffect, useState } from 'react';
import { Collapse } from 'react-collapse';
import styled from 'styled-components';
import { getColor } from '../styling/mixins/colors';
import { text } from '../styling/mixins/typography';
import Icon from './Icon';

interface CollapsibleAttributes {
  label?: string | JSX.Element;
  className?: string;
  transitionDuration?: string;
  onStateChange?: Function;
  isOpen?: boolean;
  hideBorder?: boolean;
  children?: any;
}

interface CollapsibleIconProps {
  $isOpen: boolean;
  $transitionDuration: string;
}

const StyledCollapsible = styled.div`
  label,
  button.toggle-collapsible {
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${text('xlarge')}
  }
`;

const StyledCollapsibleIcon = styled(Icon)<CollapsibleIconProps>`
  transform: ${(p) => (p.$isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  transition-duration: ${(p) => p.$transitionDuration};
  height: 20px;
  width: 20px;
`;

export default ({
  children,
  label,
  className = '',
  transitionDuration = '0.2s',
  onStateChange: externalStateChange,
  isOpen: externalIsOpen,
  hideBorder,
}: CollapsibleAttributes) => {
  const [isOpen, setIsOpen] = useState<boolean>(externalIsOpen ?? false);

  const onStateChange = (open: boolean) => {
    externalStateChange && externalStateChange(open);
    setIsOpen(open);
  };

  useEffect(() => {
    setIsOpen(externalIsOpen ?? false);
  }, [externalIsOpen]);

  return (
    <StyledCollapsible
      className={`collapsible ${className ?? ''} ${
        hideBorder ? 'collapsible--no-border' : ''
      }`}
    >
      <button
        className="toggle-collapsible"
        onClick={() => onStateChange(!isOpen)}
      >
        {label}
        <StyledCollapsibleIcon
          name="caret-down"
          $isOpen={isOpen}
          $transitionDuration={transitionDuration}
        />
      </button>
      <div className="collapsible__content">
        <Collapse isOpened={isOpen}>{children}</Collapse>
      </div>
    </StyledCollapsible>
  );
};
